<template>
  <div class="networks-page">
    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <h4 class="card-title mb-0">
          <i class="bi bi-diagram-3 me-2"></i>Networks Management
        </h4>
        <button class="btn btn-primary" @click="addNetwork">
          <i class="bi bi-plus me-2"></i>Add Network
        </button>
      </div>
      <div class="card-body">
        <div v-for="(network, index) in networks" :key="index" class="card mb-3">
          <div class="card-body">
            <div class="mb-3">
              <label class="form-label">Description</label>
              <textarea class="form-control" rows="3" v-model="network.description"></textarea>
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn btn-outline-danger btn-sm" @click="removeNetwork(index)">
                <i class="bi bi-trash"></i> Remove
              </button>
            </div>
          </div>
        </div>
        <button class="btn btn-success" @click="saveNetworks">Save Networks</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Networks',
  data() {
    return {
      networks: [
        { name: 'Clinical Research Network', description: 'Network for clinical research collaboration' }
      ]
    }
  },
  methods: {
    addNetwork() {
      this.networks.push({ name: '', description: '' })
    },
    removeNetwork(index) {
      this.networks.splice(index, 1)
    },
    saveNetworks() {
      this.$toast?.success('Networks saved successfully!')
    }
  }
}
</script>

<style scoped>
.networks-page {
  padding: 1rem 0;
}
</style>
